//
//
//
//
//
//
//
//
export default {
  name: 'TheSortsSkeleton'
};